import { isEmpty, isEqual } from 'lodash';
import moment from 'moment';
import { DateType } from 'api/models';

export const sortByDates = (
  a: DateType | undefined,
  b: DateType | undefined,
  granularity: moment.unitOfTime.Diff = 'days',
): number => {
  if (isEqual(a, b)) {
    return 0;
  }

  if (isEmpty(a)) {
    return -1;
  }

  if (isEmpty(b)) {
    return 1;
  }

  const date1 = moment(a);
  const date2 = moment(b);

  return date1.diff(date2, granularity);
};
